import Widget from "../../lib/ui/Widget";
import { observe } from "../../lib/reactive";
export class NislIcon extends Widget {
    constructor() {
        super();
        this.url = observe("");
        this.addClass("nisl-icon");
        this.img = c("<img>").appendTo(this);
        this.url.subscribe(url => {
            this.img.setAttribute("src", url);
        });
    }
    inline() {
        this.img.addClass("text-icon");
        return this;
    }
    setSource(src) {
        this.url.set(src);
        return this;
    }
    withClick(handler) {
        this.addClass("ctr-clickable");
        this.on("click", handler);
        return this;
    }
    static dropdown() {
        return new NislIcon().setSource("/assets/nis/dropdown.png");
    }
    static arrow(direction = "down") {
        return new ArrowIcon(direction);
    }
    static sectionArrow(direction) {
        const icon = new NislIcon().setSource("/assets/nis/sectionarrowright.png");
        if (direction == "left")
            icon.img.css("transform", "scaleX(-1)");
        return icon;
    }
    static info() {
        return new NislIcon().css("cursor", "help").setSource("/assets/icons/info_nis.png");
    }
    static delete() {
        return new NislIcon().setSource("/assets/icons/delete.png");
    }
    static plus() {
        return new NislIcon().setSource("/assets/nis/plus.png");
    }
    static from(url) {
        return new NislIcon().setSource(url);
    }
    static reset() {
        return new NislIcon().setSource("/assets/icons/reset_nis.png");
    }
    static reset2() {
        return new NislIcon().setSource("/assets/icons/reset.png").css("scale", 0.8);
    }
}
export class FavouriteIcon extends NislIcon {
    constructor() {
        super();
        this.toggled = observe(false);
        this.toggled.subscribe(v => {
            this.setSource(v ? "/assets/nis/favourite_on.png" : "/assets/nis/favourite_off.png");
        }, true);
        this.img.css("margin-bottom", "2px");
    }
    set(value) {
        this.toggled.set(value);
        return this;
    }
}
export class ArrowIcon extends NislIcon {
    constructor(dir = "down") {
        super();
        this.direction = observe(dir);
        this.direction.subscribe(dir => {
            this.setSource(`assets/nis/arrow_${dir}.png`);
        }, true);
    }
    setDirection(direction) {
        this.direction.set(direction);
        return this;
    }
}
export class ExpandIcon extends NislIcon {
    constructor() {
        super();
        this.img.css("width", "15px");
        this.expanded = observe(false);
        this.expanded.subscribe(expanded => {
            if (expanded)
                this.setSource(`assets/nis/minus.png`);
            else
                this.setSource(`assets/nis/plus.png`);
        }, true);
    }
    setExpanded(value) {
        this.expanded.set(value);
        return this;
    }
}
